// Get environment variables from runtime config or fallback to import.meta.env
export const getEnvVar = (key: string, placeholder: string): string => {
  // @ts-expect-error - RUNTIME_CONFIG is injected at runtime
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key]) {
    // @ts-expect-error  - RUNTIME_CONFIG key
    return window.RUNTIME_CONFIG[key];
  }
  if (import.meta.env[key]) return import.meta.env[key];
  return placeholder;
};
// Export commonly used environment variables - remember to add placeholders when introducing new env vars
export const ARGO_API_URL = getEnvVar('VITE_ARGO_API_URL', 'url_placeholder');
export const ARGO_TOKEN = getEnvVar('VITE_ARGO_TOKEN', 'User_needs_to_add_a_token');
export const ARGO_NAMESPACE = getEnvVar('VITE_ARGO_NAMESPACE', 'argo_namespace_placeholder');
// export const ARGO_LOGS_TOKEN = getEnvVar('VITE_ARGO_LOGS_TOKEN', 'logs_token_placeholder');
export const LOCAL_STORAGE_HASH_KEY = getEnvVar('VITE_SECURE_LOCAL_STORAGE_HASH_KEY', 'hash_key_placeholder');
export const ADMIN_SETUP_TOKEN = getEnvVar('VITE_ADMIN_SETUP_TOKEN', 'admin_setup_token_placeholder');
export const IS_SHOW_KPI_ANALYTICS = getEnvVar('VITE_IS_SHOW_KPI_ANALYTICS', 'boolean_condition_to_show_or_hide_netpulse_link');
export const KPI_ANALYTICS_BASE_URL = getEnvVar('VITE_KPI_ANALYTICS_BASE_URL', 'kpi_analytics_base_url');
export const KPI_ANALYTICS_DEFAULT_PASSWORD = getEnvVar('VITE_KPI_ANALYTICS_DEFAULT_PASSWORD', 'kpi_analytics_default_password');
export const SHOW_RSWOB = getEnvVar('VITE_SHOW_RSWOB', 'show_rswob_placeholder');
export const ANOMALY_DASHBOARD_URL = getEnvVar('VITE_ANOMALY_DASHBOARD_URL', 'anomaly_dashboard_url');
export const MANAGEMENT_URL = getEnvVar('VITE_MANAGEMENT_URL', 'kpi_analytics_management_url');
export const KPI_MODULE_URL = getEnvVar('VITE_KPI_MODULE_URL', 'kpi_module_url');
export const KEYCLOAK_URL = getEnvVar('VITE_KEYCLOAK_URL', '<keycloak-service-url>');

/**
 * When 'true', hides the NIA "Administration" menu group (Users, Roles,
 * Permissions, User Activities, Features) under KPI Analytics > Advanced
 * Configuration. That administration is superseded by Keycloak roles, so it
 * must not be exposed once auth is fully migrated to Keycloak.
 *
 * Feature toggle: set to any value other than 'true' (or leave the placeholder)
 * to instantly restore the legacy behaviour (menu shown per NIA permissions).
 */
export const HIDE_NIA_ADMINISTRATION = getEnvVar('VITE_HIDE_NIA_ADMINISTRATION', 'hide_nia_administration_placeholder');
export const IS_SHOW_TRACEHUNT = getEnvVar('VITE_IS_SHOW_TRACEHUNT', 'is_show_tracehunt_placeholder');
export const TRACEHUNT_MODULE_URL = getEnvVar('VITE_TRACEHUNT_MODULE_URL', 'tracehunt_module_url');
export const TRACEHUNT_API_URL = getEnvVar('VITE_TRACEHUNT_API_URL', 'tracehunt_api_url');
